package com.devi3east.bashbuddy.features.events.feed.ui

import com.devi3east.bashbuddy.features.events.common.data.models.Event

data class EventFeedUiState(
    val isLoading: Boolean = false,
    val hasCompletedInitialLoad: Boolean = false,
    val errorMessage: String? = null,
    val eventsList: List<Event> = emptyList(),
    val userCount: Int? = null
)